module.exports = __webpack_public_path__ + "static-v-shop/1786392158156/img/cybermonday-logo.0a91ce20.png";